import React, { useEffect, useState, useCallback } from "react";
import { RawMaterialPurchaseListDTO } from "../../models/RawMaterials/RawMaterial-model";
import { t } from "i18next";
import GrnReportsSearch from "./GrnReportsSearch";
import GrnReportsDatatable from "./GrnReportsDatatable";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";
import { Button } from "primereact/button";
//import { rawMaterialExport } from "../RawMaterials/RawmaterialList-Export"; // adjust if you want export here too
import { GRNReportsExport } from "./GrnExport";
const GrnReportsMain: React.FC = () => {
  const [materials, setMaterials] = useState<RawMaterialPurchaseListDTO[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [currentSortField, setCurrentSortField] = useState<string | undefined>(undefined);
  const [currentSortOrder, setCurrentSortOrder] = useState<1 | -1 | null>(null);

  const [filters, setFilters] = useState({
    rawMaterialId: null,
    rmCategoryId: null,
    activeOnly: true,
    sortColumn: "createdDate",
    sortDirection: "desc",
    keyword: "",
    invoiceNumber: null,
    posAlias: undefined,
    startDate: undefined as string | Date | undefined,
    endDate: undefined as string | Date | undefined,
    isGRNReport: true,
  });

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = useCallback((searchFilters: any) => {
    setFilters(searchFilters);
    setPageNumber(1);
  }, []);

  const fetchMaterials = useCallback(async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const payload = {
        pageNumber,
        pageSize,
        rawMaterialId: filters.rawMaterialId,
        rmCategoryId: filters.rmCategoryId,
        sortColumn: filters.sortColumn,
        sortDirection: filters.sortDirection,
        keyword: filters.keyword,
        invoiceNumber: filters.invoiceNumber,
        posAlias: filters.posAlias,
        startDate: filters.startDate,
        endDate: filters.endDate,

        isGRNReport: filters.isGRNReport,
      };

      const response = await RawMaterialService.getRawMaterialPurchases(payload);

      setMaterials(response.rawMaterialPurchases?.map((x: any) => ({ ...x })) || []);
      setTotalRecords(response.totalRecords || 0);

      setRefreshKey((p) => p + 1);
    } catch (e) {

      setMaterials([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  }, [pageNumber, pageSize, filters]);

  const handleSortChange = (field: string, order: 1 | -1) => {
    const columnMapping: Record<string, string> = {
      // NEW columns for GRN
      grnReportDate: "createdDate",          // if you use a custom field name in <Column field="grnReportDate" ... />
      createdDate: "createdDate",
      rawMaterialPurchaseId: "rawMaterialPurchaseId", // make sure API expects this exact name

      // existing mappings you already had (keep if columns exist)
      invoiceNumber: "invoiceNumber",
      createdbyName: "createdByName",
      rawMaterialName: "rawMaterialName",
      categoryName: "categoryName",
      vendorName: "vendorName",
      purchaseDate: "purchaseDate",
      quantity: "quantity",
      basicAmount: "basicAmount",
      taxAmount: "taxAmount",
      totalAmount: "totalAmount",
      updatedByName: "updatedByName",
      updatedDate: "updatedDate",
      posAlias: "posAlias",
      acceptedQuantity: "acceptedQuantity",
      rejectedQuantity: "rejectedQuantity",
      remainingQuantity: "remainingQuantity",
    };

    const mappedField = columnMapping[field] || field;

    setCurrentSortField(field);
    setCurrentSortOrder(order);

    setFilters((prev) => ({
      ...prev,
      sortColumn: mappedField,
      sortDirection: order === 1 ? "asc" : "desc",
    }));
  };

  const handleReset = useCallback(() => {
    setCurrentSortField(undefined);
    setCurrentSortOrder(null);

    setFilters({
      rawMaterialId: null,
      activeOnly: true,
      rmCategoryId: null,
      sortColumn: "createdDate",
      sortDirection: "desc",
      keyword: "",
      invoiceNumber: null,
      posAlias: undefined,
      startDate: undefined,
      endDate: undefined,
      isGRNReport: true,
    });
    setPageNumber(1);
  }, []);

  const handlePageChange = (event: any) => {
    setPageNumber(event.page + 1);
    setPageSize(event.rows);
  };

  const handleExport = useCallback(async () => {
    const payload = {
      pageNumber: 1,
      pageSize: totalRecords,
      rawMaterialId: filters.rawMaterialId,
      rmCategoryId: filters.rmCategoryId,
      startDate: filters.startDate,
      endDate: filters.endDate,
      activeOnly: filters.activeOnly,
      sortColumn: filters.sortColumn,
      sortDirection: filters.sortDirection,
      keyword: filters.keyword,
      invoiceNumber: filters.invoiceNumber,
      posAlias: filters.posAlias,
    };
    await GRNReportsExport(payload);
  }, [totalRecords, filters]);

  useEffect(() => {
    fetchMaterials();
  }, [pageNumber, pageSize, filters]);

  // return (
  //   <div className="p-3">
  //     <div className="col-12">
  //       <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
  //         <h4 className="ml-1 mb-0">{t("GRN reports")}</h4>
  //         <Button
  //           className="text-black border-round mr-2 mb-1"
  //           onClick={handleExport}
  //           icon="pi pi-file-export mr-1"
  //           text
  //           raised
  //           tooltip="Export to Excel"
  //           tooltipOptions={{ position: "top" }}
  //           style={{ width: "auto", marginLeft: "10px" }}
  //         >
  //           Export GRN Reports
  //         </Button>
  //       </div>
  //     </div>

  //     <GrnReportsSearch onSearch={handleSearch} onReset={handleReset} totalRecords={totalRecords} />

  //     <GrnReportsDatatable
  //       key={refreshKey}
  //       data={materials}
  //       pageNumber={pageNumber}
  //       pageSize={pageSize}
  //       totalRecords={totalRecords}
  //       onPageChange={handlePageChange}
  //       onSortChange={handleSortChange}
  //       sortField={currentSortField}
  //       sortOrder={currentSortOrder}
  //     />
  //   </div>
  return (
    <div style={{ marginTop: '12px', marginBottom: '12px', width: '100%', paddingLeft: '16px', paddingRight: '16px', boxSizing: 'border-box' }}>
      <div style={{ padding: '0', margin: '0', width: '100%' }}>
        {/* ===== HEADER, FILTER & SEARCH CARD (GREEN BACKGROUND) ===== */}
        <div style={{
          backgroundColor: '#e8f5e9',
          borderRadius: '12px 12px 0 0',
          marginBottom: '0',
          padding: '24px',
          width: '100%',
          boxSizing: 'border-box'
        }}>

          {/* ===== HEADER SECTION (Like Raw Material Movements) ===== */}
          <div
            className="flex align-items-center gap-3 mb-4"
            style={{
              backgroundImage: "linear-gradient(to right, white, rgb(232, 245, 233))",
              padding: "16px",
              borderRadius: "8px",
              marginLeft: "-16px",
              marginRight: "-16px",
              marginTop: "-16px",
              paddingLeft: "16px",
              paddingRight: "16px"
            }}
          >
            <div
              style={{
                backgroundColor: "rgb(76, 175, 80)",
                borderRadius: "10px",
                padding: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "48px",
                height: "48px",
              }}
            >
              <i
                className="pi pi-chart-bar"
                style={{ color: "white", fontSize: "1.5rem" }}
              ></i>
            </div>

            <div style={{ flex: 1 }}>
              <h5 className="m-0 mb-1" style={{ color: '#2d3748', fontWeight: '600' }}>
                GRN Reports
              </h5>

              <p className="m-0" style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                Track and manage Goods Receipt Notes
              </p>

              <div className="flex align-items-center gap-2 mt-2">
                <i
                  className="pi pi-chart-bar"
                  style={{ color: "rgb(76, 175, 80)" }}
                ></i>
                <span className="text-sm">
                  <b>{totalRecords}</b> GRN records found
                </span>
              </div>
            </div>
          </div>

          {/* ===== FILTER HEADER ===== */}
          <div className="flex align-items-center gap-2 mb-3">
            <i
              className="pi pi-filter"
              style={{ color: "rgb(76, 175, 80)", fontSize: '1.1rem' }}
            ></i>
            <span style={{ fontWeight: '600', color: '#2d3748', fontSize: '0.95rem' }}>
              Filter GRN Reports
            </span>
          </div>

          {/* ===== SEARCH COMPONENT ===== */}
          <GrnReportsSearch
            onSearch={handleSearch}
            onReset={handleReset}
            totalRecords={totalRecords}
            onExport={handleExport}
          />
        </div>

        {/* ===== GRN RECORDS & TABLE (WHITE BACKGROUND) ===== */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0 0 12px 12px',
          padding: '24px',
          marginTop: '0',
          overflow: 'hidden',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          {/* ===== TABLE ===== */}
          <div style={{ width: '100%', padding: '0', margin: '0' }}>
            <GrnReportsDatatable
              key={refreshKey}
              data={materials}
              pageNumber={pageNumber}
              pageSize={pageSize}
              totalRecords={totalRecords}
              onPageChange={handlePageChange}
              onSortChange={handleSortChange}
              sortField={currentSortField}
              sortOrder={currentSortOrder}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrnReportsMain;
